export const SHOW_PASSWORD_RESET_MODAL = 'SHOW_PASSWORD_RESET_MODAL';
export const ENABLE_PASSWORD_RESET_BUTTON = 'ENABLE_PASSWORD_RESET_BUTTON';
export const INVALID_TOKEN = 'INVALID_TOKEN';
export const TOKEN = 'TOKEN';
